module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-backplates.72ec30a0.png";